import { memo } from 'react';
import { TabPanelStyled } from './Tabs.styles';

type IValue = string | number;

interface props {
  currentTab?: IValue;
  value: IValue;
  children?: JSX.Element | JSX.Element[] | string;
}

const TabPanel: React.FC<props> = ({ currentTab, value, children }) => {
  const isActive = currentTab === value;

  return (
    <TabPanelStyled style={{ display: isActive ? 'block' : 'none' }}>
      {isActive && children}
    </TabPanelStyled>
  );
};

export default memo(TabPanel);
